const GA_MEASUREMENT_ID = 'G-J9P9XZGDSM'

declare global {
    interface Window {
        gtag?: (...args: any[]) => void
    }
}

function safeGtag(...args: any[]) {
    if (typeof window === 'undefined') return
    if (typeof window.gtag !== 'function') return
    window.gtag(...args)
}

export const gtagAnalytics = {
    init(userId?: string) {
        safeGtag('js', new Date())
        safeGtag('config', GA_MEASUREMENT_ID, userId ? { user_id: userId } : undefined)
    },

    pageview(path: string, title?: string) {
        safeGtag('event', 'page_view', {
            page_path: path,
            page_title: title
        })
    },

    modalView(name: string) {
        // GA4 doesn't have modalview; treat as a screen_view-ish event
        safeGtag('event', 'screen_view', {
            screen_name: name,
            screen_type: 'modal'
        })
    },

    event(category: string, action: string, options: any = {}) {
        // Keep your existing shape but map to GA4 params
        const { label, value, ...rest } = options || {}

        safeGtag('event', action, {
            event_category: category,
            event_label: label,
            value,
            ...rest
        })
    },

    exception(description: string, fatal?: boolean) {
        safeGtag('event', 'exception', {
            description,
            fatal
        })
    },

    outboundLink(link: string) {
        safeGtag('event', 'outbound_click', {
            link_url: link
        })
    },

    setUserProperties(props: Record<string, any>) {
        // Rough equivalent of ReactGA.set / custom dimensions → GA4 user properties
        safeGtag('set', 'user_properties', props)
    }
}
